module.exports = __webpack_public_path__ + "static/img/planetEn2.6cc7dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planet/planetEn2.png
// module id = SDUT
// module chunks = 1